import { computed } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore, useURLStore } from 'src/store'

export default function useTheHeaderPersonalAreaUrl() {
  const { context }: ContextStore = useContextStore()
  const { reverse } = useURLStore()

  const personalAreaUrl = computed(() => {
    const { siteNamePD } = context.global?.sites || {}
    const sitePd = String(siteNamePD || 'https://prodoctorov.ru/')
    const isLpuPage = String(context.request?.path || '').includes('/lpu/')
    const isDoctorPage = String(context.request?.path || '').includes('/vrach/')

    if (!context.request?.user?.is_authenticated) {
      return ''
    }

    if (!context.is_fake_user) {
      if (context.request.user.patient_profile) {
        return reverse({ name: 'medtochka:redirect_to_medtochka' })
      }

      if (context.request.user.user2?.is_doctor) {
        return new URL('profile/doctors/', sitePd).href
      }

      if (context.request.user.user2?.is_lpu) {
        return new URL('profile/lpus/', sitePd).href
      }
    }

    if (context.lpu?.owner && isLpuPage) {
      const url = new URL('profile/lpus/', sitePd)

      url.searchParams.set('lpu', String(context.lpu.id))
      return url.href
    }

    if (context.lpu && !context.lpu.owner && isLpuPage) {
      const url = new URL('cabinet/', sitePd)

      url.searchParams.set('lpu', String(context.lpu.id))
      return url.href
    }

    if (context.doctor?.owner && isDoctorPage) {
      const url = new URL('profile/doctors/', sitePd)

      url.searchParams.set('doctor', String(context.doctor.id))
      return url.href
    }

    return ''
  })

  return {
    personalAreaUrl,
  }
}
